export const logout = () => {
  localStorage.removeItem("cipm-membership-data");
  localStorage.removeItem("cipm-membership-profile");
  window.location.href = "/";
}